import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shirdicarrentalservice() {



  const cardData =
  {
    keyword: 'Shirdi Car Rental Service',
    heading: 'Sanavi Travels: Shirdi Car Rental Service',
    headingDescription: 'Sanavi Travels offers reliable Shirdi Car Rental Service, providing safe, comfortable, and hassle-free transportation for pilgrims, families, and tourists visiting the holy town of Shirdi. Our fleet of well-maintained hatchbacks, sedans, SUVs, and luxury cars ensures spacious seating, air-conditioning, and ample luggage space for a smooth and peaceful journey. With professional chauffeurs, flexible one-way and round-trip car rental options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient pickup and drop services from Pune, Mumbai, Nashik, Aurangabad, and nearby cities, covering major attractions such as Sai Baba Temple, Dwarkamai, Chavadi, Lendi Baug, and Shani Shingnapur. Choose Sanavi Travels for trusted Shirdi car rental services, delivering comfort, safety, and a spiritually fulfilling travel experience.',

    top: 'Top Places to Visit in Shirdi with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "Shirdi Sai Baba Temple is one of India’s most revered pilgrimage sites, dedicated to Sai Baba. Devotees from all religions visit the temple seeking blessings, faith, and inner peace. The daily aartis and well-organized darshan system make the spiritual experience deeply fulfilling."
  },
  {
    "title": "Dwarkamai",
    "description": "Dwarkamai is the sacred mosque where Sai Baba lived for many years and performed miracles. The holy dhuni (sacred fire) still burns here, symbolizing faith and protection. It holds immense spiritual importance for Sai Baba devotees."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is a historic place where Sai Baba used to rest on alternate nights. Processions are held every Thursday and festival days, recreating Sai Baba’s routine and preserving the traditions followed during his lifetime."
  },
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The Samadhi Mandir houses the tomb of Sai Baba and is the central shrine of Shirdi. Devotees experience a profound sense of devotion and peace while offering prayers at the samadhi, making it the heart of Shirdi pilgrimage."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a peaceful garden where Sai Baba spent time meditating. It features the Nanda Deep lamp, which is continuously lit, and is considered a place of calm, reflection, and spiritual healing."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple holds historical importance as the place where Sai Baba was first welcomed into Shirdi. The temple is associated with Sai Baba’s early days and remains an important stop for pilgrims."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a devotional theme park showcasing scenes from Sai Baba’s life through statues and recreated settings. It helps visitors understand Sai Baba’s teachings and daily life in a visual and engaging way."
  },
  {
    "title": "Abdul Baba’s Cottage",
    "description": "Abdul Baba’s Cottage is dedicated to one of Sai Baba’s closest disciples. The site reflects the deep bond between Sai Baba and Abdul Baba and is visited by devotees seeking blessings and spiritual inspiration."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Located near Shirdi, Shani Shingnapur is famous for its open-door houses and the powerful temple of Lord Shani. Devotees often visit this temple along with Shirdi, believing it removes obstacles and negative influences."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park offers a fun-filled recreational experience for families visiting Shirdi. With water rides, wave pools, and entertainment zones, it provides a refreshing break alongside spiritual travel."
  }
]
,



"services": [
  {
    "name": "Shirdi Car Rental Service",
    "description": "Shirdi Car Rental Service provides reliable and comfortable car rental solutions for devotees and travelers visiting Shirdi. Well-maintained, air-conditioned cars with clean interiors and ample seating ensure a smooth journey for temple visits, sightseeing, and local travel. Professional chauffeurs handle navigation, traffic, and parking efficiently, allowing passengers to focus on darshan and devotion. Suitable for families, senior citizens, and tourists, this service supports local trips, outstation travel, and flexible travel schedules around Shirdi."
  },
  {
    "name": "Car Hire in Shirdi",
    "description": "Car Hire in Shirdi offers convenient and hassle-free transportation for visitors arriving for Sai Baba darshan and nearby sightseeing. The service includes comfortable AC cars, experienced drivers, and flexible pickup and drop options. Ideal for short trips, full-day rentals, and outstation journeys, it ensures punctual service, smooth driving, and a relaxed travel experience for families, couples, and solo travelers."
  },
  {
    "name": "AC Car Rental Shirdi",
    "description": "AC Car Rental Shirdi ensures a cool and comfortable ride for devotees and tourists traveling in and around Shirdi. Fully air-conditioned vehicles with spacious seating, clean interiors, and smooth suspension reduce travel fatigue, especially during hot weather. Professional chauffeurs ensure safe driving and timely travel, making this service ideal for temple visits, sightseeing, and nearby city trips."
  },
  {
    "name": "Taxi Service Shirdi",
    "description": "Taxi Service Shirdi provides dependable and efficient taxi solutions for local and outstation travel. Comfortable cars with trained drivers ensure safe and punctual journeys for Sai Mandir visits, hotel transfers, and sightseeing. Suitable for families, senior citizens, and tourists, this service focuses on reliability, convenience, and stress-free travel throughout Shirdi."
  },
  {
    "name": "Affordable Car Rental Shirdi",
    "description": "Affordable Car Rental Shirdi offers budget-friendly car rental options without compromising comfort or safety. Clean, air-conditioned cars with experienced chauffeurs ensure a smooth journey at economical pricing. Ideal for families, pilgrims, and group travelers, this service balances affordability, reliability, and convenience for Shirdi travel."
  },
  {
    "name": "Chauffeur Driven Car Shirdi",
    "description": "Chauffeur Driven Car Shirdi provides a stress-free travel experience with professional drivers managing routes, traffic, and schedules. Comfortable AC cars allow passengers to relax during temple visits, local travel, and outstation trips. Ideal for elderly devotees, families, and tourists, this service emphasizes safety, punctuality, and personalized travel support."
  },
  {
    "name": "Best Car Service in Shirdi",
    "description": "Best Car Service in Shirdi delivers high-quality and dependable transportation with well-maintained vehicles and trained chauffeurs. Fully air-conditioned cars ensure comfort for temple darshan, sightseeing, and outstation travel. Known for punctuality, courteous service, and reliability, this option suits families, VIP guests, and regular Shirdi visitors."
  },
  {
    "name": "Shirdi Local Taxi",
    "description": "Shirdi Local Taxi is ideal for short-distance travel within Shirdi, including Sai Mandir visits, hotels, and nearby attractions. Comfortable AC taxis with knowledgeable drivers ensure quick and convenient local movement. Suitable for all travelers, this service offers flexible timings, easy availability, and smooth local travel."
  },
  {
    "name": "Airport Pickup Shirdi",
    "description": "Airport Pickup Shirdi ensures timely and hassle-free transfers from nearby airports to Shirdi. Professional drivers track flight timings and provide punctual pickups in comfortable, air-conditioned cars. Ideal for devotees, tourists, and business travelers, this service guarantees a smooth start to the Shirdi journey."
  },
  {
    "name": "Outstation Car Shirdi",
    "description": "Outstation Car Shirdi offers reliable long-distance travel options from Shirdi to nearby cities and pilgrimage destinations. Well-maintained AC cars with experienced chauffeurs ensure safe highway driving, comfortable seating, and timely arrivals. Suitable for family trips, temple tours, and extended travel plans."
  },
  {
    "name": "Family Car Rental Shirdi",
    "description": "Family Car Rental Shirdi is designed to make family travel safe, comfortable, and convenient. Spacious AC cars with ample luggage space accommodate all family members easily. Professional drivers ensure smooth driving and flexible travel plans, making it ideal for family darshan trips and sightseeing."
  },
  {
    "name": "Tourist Taxi Shirdi",
    "description": "Tourist Taxi Shirdi provides organized transportation for sightseeing and leisure travel around Shirdi and nearby attractions. Comfortable air-conditioned cars with knowledgeable chauffeurs ensure a pleasant and informative journey. Perfect for families, couples, and tourists planning temple visits and local tours."
  },
  {
    "name": "Online Car Booking Shirdi",
    "description": "Online Car Booking Shirdi allows customers to easily reserve cars for Shirdi travel anytime. Users can choose car type, pickup location, travel duration, and trip preferences with instant confirmation. Fully air-conditioned vehicles with professional chauffeurs ensure safe, reliable, and convenient travel planning."
  },
  {
    "name": "Cab Service Near Sai Mandir",
    "description": "Cab Service Near Sai Mandir provides quick and convenient taxi availability close to the temple area. Ideal for elderly devotees and families, this service ensures easy access, comfortable cars, and experienced drivers for short and long trips around Shirdi."
  },
  {
    "name": "Shirdi Travel Car",
    "description": "Shirdi Travel Car offers dedicated car rental solutions for pilgrims and tourists visiting Shirdi. Comfortable AC cars with trained chauffeurs ensure smooth travel for darshan, sightseeing, and outstation journeys. This service focuses on comfort, safety, flexibility, and a peaceful travel experience."
  }
],
"tableData": [
  ["Shirdi Car Rental Service", "Car Hire in Shirdi"],
  ["AC Car Rental Shirdi", "Taxi Service Shirdi"],
  ["Affordable Car Rental Shirdi", "Chauffeur Driven Car Shirdi"],
  ["Best Car Service in Shirdi", "Shirdi Local Taxi"],
  ["Airport Pickup Shirdi", "Outstation Car Shirdi"],
  ["Family Car Rental Shirdi", "Tourist Taxi Shirdi"],
  ["Online Car Booking Shirdi", "Cab Service Near Sai Mandir"],
  ["Shirdi Travel Car", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Shirdi Car Rental Service with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable Shirdi car rental services, perfect for pilgrimages, family trips, airport transfers, and local sightseeing."
  },
  {
    "WhyChooseheading": "Wide Range of Well-Maintained Cars",
    "WhyChoosedescription": "Choose from a variety of clean, air-conditioned cars including sedans, SUVs, and premium vehicles to suit your Shirdi travel needs."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with the routes to and around Shirdi, ensuring safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Shirdi car rentals, including fuel, tolls, and driver allowances with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your Shirdi trip."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, local hourly rentals, or customized travel packages to Shirdi based on your preferences."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cars are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic journey."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Shirdi car rental services."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide car rental services for Shirdi?',
    answer: 'Yes, Sanavi Travels offers professional and reliable car rental services for Shirdi travel.'
  },
  {
    question: 'How can I book a Shirdi car rental?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cars are available for Shirdi travel?',
    answer: 'Sanavi Travels provides sedans, SUVs, and premium cars suitable for Shirdi trips.'
  },
  {
    question: 'Are the drivers experienced with Shirdi routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Shirdi routes for safe and timely travel.'
  },
  {
    question: 'Can I customize my Shirdi travel itinerary?',
    answer: 'Absolutely. We offer customizable travel plans including one-way, round-trip, and local rentals.'
  },
  {
    question: 'Is customer support available during the trip?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Shirdi car rental journey.'
  },
  {
    question: 'Are the cars sanitized before every trip?',
    answer: 'Yes, all cars are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'What payment options are available for Shirdi car rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is pricing transparent with no hidden charges?',
    answer: 'Yes, Sanavi Travels provides clear and upfront pricing for all Shirdi car rental services.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Gupta',
    feedback: 'Booked a car rental for Shirdi trip. Comfortable car, professional driver, and smooth journey throughout.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha More',
    feedback: 'Excellent service! Clean car, reliable support, and punctual service made our Shirdi trip memorable.',
    rating: 5
  }
];







































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shirdi Car Rental Service - Sanavi Travels",
  "description": "Book AC and luxury cars in Shirdi with Sanavi Travels. Ideal for airport pickups, Sai Baba Darshan, family trips, outstation travel, local tours, and chauffeur-driven comfortable journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Shirdi Car Rental Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury cars in Shirdi with Sanavi Travels. Perfect for Sai Baba Darshan, airport pickups, family trips, local travel, outstation tours, and safe chauffeur-driven journeys."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/85.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Shirdicarrentalservice;